import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import './Header.css';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="header-content">
        <div className="logo-container" onClick={() => scrollToSection('hero')}>
          <img src="/logo.jpg" alt="Kothu Rotti" className="logo" />
        </div>

        <nav className="desktop-nav">
          <button onClick={() => scrollToSection('about')} className="nav-link">About</button>
          <button onClick={() => scrollToSection('menu')} className="nav-link">Menu</button>
          <button onClick={() => scrollToSection('combos')} className="nav-link">Combos</button>
          <button onClick={() => scrollToSection('gallery')} className="nav-link">Gallery</button>
          <button onClick={() => scrollToSection('locations')} className="nav-link">Locations</button>
          <button onClick={() => scrollToSection('contact')} className="nav-link">Contact</button>
        </nav>

        <div className="header-actions">
          <a href="tel:0141 378 3469" className="btn-primary">Book Now</a>
        </div>

        <button 
          className="mobile-menu-toggle"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {isMobileMenuOpen && (
        <div className="mobile-menu">
          <button onClick={() => scrollToSection('about')} className="mobile-nav-link">About</button>
          <button onClick={() => scrollToSection('menu')} className="mobile-nav-link">Menu</button>
          <button onClick={() => scrollToSection('combos')} className="mobile-nav-link">Combos</button>
          <button onClick={() => scrollToSection('gallery')} className="mobile-nav-link">Gallery</button>
          <button onClick={() => scrollToSection('locations')} className="mobile-nav-link">Locations</button>
          <button onClick={() => scrollToSection('contact')} className="mobile-nav-link">Contact</button>
        </div>
      )}
    </header>
  );
};

export default Header;
